import {useQuery} from "react-query";
import userProfileService from "../../services/UserProfileService";

export default function useUserProfile() {
   return useQuery(['profile'], () => userProfileService.get(), {
      retry: false
   });
}